<template>
  <el-dialog
    :visible.sync="visible"
    :close-on-click-modal="false"
    append-to-body
    width="25%"
  >
    <div class="pop">
      <img :src="popData.img" alt="" />
      <div class="blue" :class="popData.orige === true ? 'ogrir' : ''">
        {{ popData.bule }}
      </div>
      <div class="grey">{{ popData.grey }}</div>
      <div>
        <el-button type="info" @click="close">&nbsp;关闭&nbsp;</el-button>
        <slot name="once"></slot>
        <slot name="again"></slot>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    successVisible: {
      type: Boolean,
      default: false,
    },
    popData: {
      type: Object,
      default: null,
    },
  },
  computed: {
    visible: {
      get() {
        return this.successVisible;
      },
      set(v) {
        this.$emit("update:successVisible", v);
      },
    },
  },
  created() {},
  mounted() {},
  methods: {
    close() {
      this.visible = false;
    },
  },
};
</script>

<style lang='less' scoped>
.pop {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  img {
    width: 28%;
  }
  .blue {
    color: #3b7df9;
    margin-top: 20PX;
    font-size: 20PX;
  }
  .grey {
    color: #98a1bc;
    margin: 20PX 0;
    font-size: 18PX;
  }
  .ogrir {
    color: #ff7751;
  }
}
</style>